module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_i04.4a9efcaa.svg";